import CryptoJS from 'crypto-js';

export const decryptData = (encryptedData, secretKey) => {
    const key = CryptoJS.enc.Base64.parse(secretKey);
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);

    // Extraer IV (16 bytes primeros)
    const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4)); // 4 words = 16 bytes

    // Extraer texto cifrado (después de los primeros 16 bytes)
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext },
        key,
        { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
};

export const encryptData = (stringdata, secretKey) => {
    const key = CryptoJS.enc.Base64.parse(secretKey);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
        stringdata,
        key,
        { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    let encryptedData = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));
    encryptedData = encryptedData.replace(/\//g, 'UUU');
    return encryptedData;
};